import { elakay_API } from '../config';
import { legacyFilePath } from './legacyFilePaths';

export const DEFAULT_APP_PWA = Object.freeze({
  appName: 'Elakay', shortName: 'Elakay',
  // Served by GET /elakay_api/files/... (nginx forwards only /elakay_api/*).
  iconBaseUrl: '/elakay_api/files/app-pwa-default', iconRevision: 'default-coral-v3',
  sourcePreserved: false,
  backgroundColor: '#ef746d', backgroundColorSecondary: '#ffaaa0',
  transparentBackground: false, uniformBackground: false,
  iconMargin: 0, iconPadding: 0, iconScale: 88, trimTransparentSpace: false,
  mobileEnabled: true, tabletEnabled: true, desktopEnabled: true,
  iosEnabled: true, androidEnabled: true, pwaInstallEnabled: true,
});

export const apiOrigin = () => {
  try { return new URL(elakay_API, window.location.origin).origin; }
  catch (_) { return window.location.origin; }
};

// Settings saved before the API route keep /data/images/app-pwa/...
export const normalizeIconBaseUrl = (value) => {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  if (!raw) return DEFAULT_APP_PWA.iconBaseUrl;
  if (raw.startsWith('/elakay_api/files/app-pwa')) return raw;
  return legacyFilePath(raw) || DEFAULT_APP_PWA.iconBaseUrl;
};

export const appIconUrl = (settings, file = 'icon-512.png') => {
  const value = { ...DEFAULT_APP_PWA, ...(settings || {}) };
  value.iconBaseUrl = normalizeIconBaseUrl(value.iconBaseUrl);
  if (value.iconBaseUrl === DEFAULT_APP_PWA.iconBaseUrl && ['default-v1', 'default-coral-v2'].includes(value.iconRevision)) value.iconRevision = DEFAULT_APP_PWA.iconRevision;
  return `${apiOrigin()}${value.iconBaseUrl}/${file}?v=${encodeURIComponent(value.iconRevision)}`;
};

export const applyAppPwaSettings = (raw) => {
  if (typeof document === 'undefined') return;
  const settings = { ...DEFAULT_APP_PWA, ...(raw || {}) };
  const width = window.innerWidth;
  const deviceEnabled = width < 768 ? settings.mobileEnabled : width < 1100 ? settings.tabletEnabled : settings.desktopEnabled;
  const userAgent = navigator.userAgent || '';
  const isIos = /iPad|iPhone|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const platformEnabled = isIos ? settings.iosEnabled : isAndroid ? settings.androidEnabled : true;
  if (!deviceEnabled || !platformEnabled) {
    document.title = 'Elakay';
    document.head.querySelector('link[rel="manifest"]')?.remove();
    document.head.querySelector('link[rel="apple-touch-icon"]')?.remove();
    return;
  }
  document.title = settings.appName || 'Elakay';
  const ensure = (selector, attributes) => {
    let node = document.head.querySelector(selector);
    if (!node) { node = document.createElement(attributes.tag || 'meta'); document.head.appendChild(node); }
    Object.entries(attributes).forEach(([key, value]) => key !== 'tag' && node.setAttribute(key, value));
    return node;
  };
  ensure('meta[name="application-name"]', { tag: 'meta', name: 'application-name', content: settings.appName });
  ensure('meta[name="apple-mobile-web-app-title"]', { tag: 'meta', name: 'apple-mobile-web-app-title', content: settings.shortName });
  ensure('link[rel="icon"]', { tag: 'link', rel: 'icon', type: 'image/png', href: appIconUrl(settings, 'favicon-64.png') });
  const apple = document.head.querySelector('link[rel="apple-touch-icon"]');
  if (settings.iosEnabled) ensure('link[rel="apple-touch-icon"]', { tag: 'link', rel: 'apple-touch-icon', href: appIconUrl(settings, 'apple-touch-icon.png') });
  else apple?.remove();
  const manifest = document.head.querySelector('link[rel="manifest"]');
  if (settings.pwaInstallEnabled) {
    ensure('link[rel="manifest"]', { tag: 'link', rel: 'manifest', href: `${elakay_API}/app-manifest.webmanifest?v=${encodeURIComponent(settings.iconRevision)}` });
  } else manifest?.remove();
};
